import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { FiMenu, FiBell, FiUser, FiLogOut, FiSettings } from 'react-icons/fi';
import styles from './Header.module.css';
import logoHorizontal from '../assets/logos/logo 2.png';

const Header = ({ onToggleSidebar, sidebarOpen }) => {
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const { user, logout } = useAuth();

  const handleLogout = () => {
    logout();
    setUserMenuOpen(false);
  };

  const toggleUserMenu = () => {
    setUserMenuOpen(!userMenuOpen);
  };

  return (
    <header className={styles.header}>
      <div className={styles.leftSection}>
        <button
          onClick={onToggleSidebar}
          className={styles.menuButton}
          aria-label="Toggle menu"
        >
          <FiMenu />
        </button>
        
        <div className={styles.logo}>
          <img src={logoHorizontal} alt="Lumi One" className={styles.logoImage} />
        </div>
      </div>

      <div className={styles.rightSection}>
        {/* Notificações */}
        <button className={styles.iconButton} aria-label="Notificações">
          <FiBell />
          <span className={styles.badge}>3</span>
        </button>

        {/* Menu do usuário */}
        <div className={styles.userMenu}>
          <button
            onClick={toggleUserMenu}
            className={styles.userButton}
            aria-label="Menu do usuário"
          >
            <div className={styles.userAvatar}>
              <FiUser />
            </div>
            <div className={styles.userInfo}>
              <span className={styles.userName}>
                {user?.nome || user?.email || 'Usuário'}
              </span>
              <span className={styles.userRole}>
                {user?.role || 'Usuário'}
              </span>
            </div>
          </button>

          {userMenuOpen && (
            <div className={styles.userDropdown}>
              <div className={styles.dropdownHeader}>
                <div className={styles.userAvatarLarge}>
                  <FiUser />
                </div>
                <div>
                  <div className={styles.dropdownUserName}>
                    {user?.nome || user?.email || 'Usuário'}
                  </div>
                  <div className={styles.dropdownUserEmail}>
                    {user?.email}
                  </div>
                </div>
              </div>
              
              <div className={styles.dropdownDivider}></div>
              
              <button className={styles.dropdownItem}>
                <FiUser />
                Meu Perfil
              </button>
              
              <button className={styles.dropdownItem}>
                <FiSettings />
                Configurações
              </button>
              
              <div className={styles.dropdownDivider}></div>
              
              <button
                onClick={handleLogout}
                className={`${styles.dropdownItem} ${styles.logoutItem}`}
              >
                <FiLogOut />
                Sair
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Overlay para fechar o menu */}
      {userMenuOpen && (
        <div
          className={styles.menuOverlay}
          onClick={() => setUserMenuOpen(false)}
        />
      )}
    </header>
  );
};

export default Header;